import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import store from './store/vuex'
import utils from './utils/utils'
import accessCode from './localStorage/accessCode'
import moment from 'moment'

import recaptchaPlugin from './plugins/recaptcha'
import VueDOMPurifyHTML from 'vue-dompurify-html'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueApexCharts from 'vue3-apexcharts'

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { $axios } from './axios/axios-config'

import intersect from './directives/intersect'
import { resetStorageOnNewBuild } from './utils/buildVersion'

resetStorageOnNewBuild()

const app = createApp(App)

app.use(router)
app.use(store)
app.use(recaptchaPlugin)
app.use(VueDOMPurifyHTML, {
  default: {
    allowedTags: [
      'p',
      'br',
      'strong',
      'em',
      'code',
      'pre',
      'i',
      'ul',
      'ol',
      'li',
      'div',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
    ],
    allowedAttributes: {},
  },
})
app.component('Multiselect', Multiselect)
app.use(VueSweetalert2)
app.use(VueApexCharts)
app.component('VueDatePicker', VueDatePicker)

app.config.globalProperties.$utils = utils
app.config.globalProperties.$moment = moment
app.config.globalProperties.$accessCode = accessCode
app.config.globalProperties.$axios = {
  ...$axios,
}

const clickOutside = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        if (typeof binding.value === 'function') {
          binding.value(event)
        }
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    document.removeEventListener('click', el.clickOutsideEvent)
  },
}

app.directive('click-outside', clickOutside)
app.directive('animate', intersect)

// On first visit there is no languageCode cookie yet; the backend LanguageMiddleware
// sets it (default language) on the first API response. Wait for it before mounting,
// otherwise all Squidex queries run with an undefined lang.
async function ensureLanguageCookie() {
  if (utils.getCookie()) return
  try {
    await $axios.get('/api/Language/getLanguages')
  } catch {
    // mount anyway
  }
}

ensureLanguageCookie().finally(() => app.mount('#app'))
